import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { Empty } from "../assets";
import { EmptyDataProps } from "../interfaceTypes";
import { emptyBox } from "../theme/styleConstants";

export const NoDataFound: FC<EmptyDataProps> = ({ description, height }) => (
  <Box height={height} sx={emptyBox}>
    {Empty()}

    <Typography variant="h5" marginTop="2rem" color="black">
      {description}
    </Typography>
  </Box>
);
